import React from "react";
import { useActivePath } from "../shared/ActivePathContext";
import Brand from "../shared/brand/Brand";
import Nav from "../shared/nav/Nav";
import NavItem from "../shared/navItem/NavItem";
import NavSignoutBar from "../shared/navSignoutBar/NavSignoutBar";
import { HorizontalNavigationSpacer } from "./HorizontalNavigationStyles";
import NavMenu from "./navMenu/NavMenu";
import NavStatus from "./navStatus/NavStatus";
import Navbar from "./navbar/Navbar";
const HorizontalNavigation = ({ config, customLinkComponent }) => {
    const { loggedIn, username, startLogo, centerLogo, endLogo, navigationLinks = [], usernameDropdownLinks = [], builds = [], env = "prod", displayEnvIndicator = false, displayPermissionsIndicator = false, permissions = undefined, status, } = config;
    const { isActivePath } = useActivePath();
    return (React.createElement(React.Fragment, null,
        loggedIn && (React.createElement(NavSignoutBar, { username: username, links: usernameDropdownLinks, displayEnvIndicator: displayEnvIndicator, displayPermissionsIndicator: displayPermissionsIndicator, permissions: permissions, env: env })),
        React.createElement(Navbar, { loggedIn: loggedIn },
            !!startLogo?.visible && (React.createElement(Nav, { align: "start" },
                React.createElement(Brand, { logo: startLogo.logo, link: startLogo.link, text: startLogo.text, contentHeight: startLogo.logoHeight, builds: builds, customLinkComponent: customLinkComponent }))),
            loggedIn && !!navigationLinks?.length && (React.createElement(Nav, null, navigationLinks.map((link) => {
                if (link.visible !== false) {
                    if (!!link.subLinks?.length) {
                        return React.createElement(NavMenu, { ...link, customLinkComponent: customLinkComponent, key: link.name });
                    }
                    else {
                        return (React.createElement(NavItem, { ...link, active: isActivePath(link), customLinkComponent: customLinkComponent, key: link.name }));
                    }
                }
                else {
                    return null;
                }
            }))),
            !!centerLogo?.visible && (React.createElement(Nav, { align: "center" },
                React.createElement(Brand, { logo: centerLogo.logo, link: centerLogo.link, text: centerLogo.text, contentHeight: centerLogo.logoHeight, customLinkComponent: customLinkComponent }))),
            !!endLogo?.visible && (React.createElement(Nav, { align: "end" },
                React.createElement(Brand, { logo: endLogo.logo, link: endLogo.link, text: endLogo.text, contentHeight: endLogo.logoHeight, customLinkComponent: customLinkComponent })))),
        loggedIn && React.createElement(NavStatus, { status: status }),
        React.createElement(HorizontalNavigationSpacer, { "$loggedIn": loggedIn, "$hasStatus": !!status?.text?.length })));
};
export default HorizontalNavigation;
//# sourceMappingURL=HorizontalNavigation.js.map